module.exports = __webpack_public_path__ + "img/choithrams-original-480.9a57b0ef.png";